module.exports = __webpack_public_path__ + "img/logo_NU_muslimat.76155a48.png";